import React from 'react';
import SashiDo from 'lib/SashiDo';
import { addOrUpdate } from 'lib/helpers';
import Button from 'components/Button/Button.react';
import DashboardView from 'dashboard/DashboardView.react';
import LoaderContainer from 'components/LoaderContainer/LoaderContainer.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import SashiDoParse from '../SashiDoParse';
import styles from './Settings.scss';
import DeploymentsView from './DeploymentsView.react';


const { SASHIDO_API_URL, SASHIDO_API_ID, SASHIDO_API_JS_KEY } = process.env;
const Deployment = SashiDoParse.Object.extend('Deployment');

export default class Deployments extends DashboardView {
  constructor() {
    super();
    this.section = 'Runtime';
    this.subsection = 'Deployments';

    this.state = {
      loading: false,
      deployments: [],
    };

    this.subscriptionDeployment = null;
  }

  onLoadComplete = () => {
    this.setState({ loading: true });
  }

  async componentDidMount() {
    const appId = this.context.currentApp.id;
    const deployments = await this.getDeployments();

    this.setState({
      deployments,
    });

    const userObject = JSON.parse(window.localStorage.getItem(`SashiDo/${SASHIDO_API_ID}/currentUser`));
    const sessionToken = userObject ? userObject.sessionToken : '';

    this.client = new SashiDoParse.LiveQueryClient({
      applicationId: SASHIDO_API_ID,
      serverURL: SASHIDO_API_URL.replace('https', 'wss'),
      javascriptKey: SASHIDO_API_JS_KEY,
    });

    this.client.open();

    const query = new SashiDoParse.Query(Deployment);
    query.equalTo('app', { __type: 'Pointer', className: 'App', objectId: appId });
    this.subscriptionBuild = this.client.subscribe(query, sessionToken);

    // Build
    this.subscriptionBuild.on('create', (obj) => {
      const newDeployments = addOrUpdate(deployments, 'objectId', { ...obj.attributes, objectId: obj.id });
      this.setState({
        deployments: newDeployments,
      });
    });

    this.subscriptionBuild.on('update', async (obj) => {
      const newDeployments = addOrUpdate(deployments, 'objectId', { ...obj.attributes, objectId: obj.id });

      const runningBuild = obj.attributes.phase !== 'Complete' ? { runningBuild: true } : {};
      let cancelled = {};

      if (obj.attributes.phase === 'Cancelled') {
        const d = await this.getDeployments();

        cancelled = {
          deployments: d,
          runningBuild: false,
        };
      }

      let sss = {};

      if (obj.attributes.phase === 'Active') {
        sss = { runningBuild: false };
      }

      this.setState({
        deployments: newDeployments,
        ...runningBuild,
        ...cancelled,
        ...sss,
      });
    });
  }

  componentWillUnmount() {
    if (this.client) {
      this.client.close();
      this.client = null;
    }

    if (this.subscriptionDeployment) {
      this.subscriptionDeployment.unsubscribe();
      this.subscriptionDeployment = null;
    }
  }

  getDeployments = async () => {
    const appId = this.context.currentApp.id;

    const deployments = await SashiDo.appDeployments({
      appId,
    });

    return deployments;
  }

  onStartDeployHandler = () => {
    this.setState({
      runningBuild: true,
    });

    SashiDo.startDeployment({ appId: this.context.currentApp.id });
  }

  cancelHandler = async (name) => {
    const appId = this.context.currentApp.id;

    await SashiDo.cancelDeployment({
      appId,
      name,
    }).catch(() => {

    });

    this.setState({
      runningBuild: false,
    });
  }

  renderContent() {
    const { runningBuild, deployments } = this.state;

    return (
      <div>
        <Toolbar section={this.section} subsection={this.subsection}>
          <Button
            color="blue"
            value="Start Deploy"
            disabled={runningBuild}
            onClick={this.onStartDeployHandler} />
        </Toolbar>
        <div className={[styles.settings_page, this.state.showFooter ? styles.showFooter : ''].join(' ')}>
          <div className={styles.holder}>
            <LoaderContainer loading hideAnimation={this.state.loading} inner>
              <DeploymentsView
                currentApp={this.context.currentApp}
                appId={this.context.currentApp.id}
                onLoadComplete={this.onLoadComplete}
                cancelHandler={this.cancelHandler}
                deployments={deployments} />
            </LoaderContainer>
          </div>
        </div>
      </div>
    );
  }
}
